import { Span, Spinner } from "@goodfill/ui-components";

const _FullWidthSpinner = () => (
  <div className="flex justify-center">
    <Span primary={true} size="4xl">
      <Spinner />
    </Span>
  </div>
);

export const FullWidthSpinner = (props: { topSpace?: boolean }) => {
  if (props.topSpace === true) {
    return (
      <div style={{ marginTop: "42px", width: "100%" }}>
        <_FullWidthSpinner />
      </div>
    );
  }

  return <_FullWidthSpinner />;
};
